import type { DeepString } from "@/lib/i18n";

/**
 * CJobOffers - polskie tłumaczenia (Oferty pracy - lista + szczegół oferty).
 *
 * Sekcje `tasks` / `expectations` / `offer` wprowadzane są przez admina jako HTML
 * w panelu CMS - tu tłumaczymy tylko etykiety wprowadzające ("Będziesz odpowiedzialny za:" itp).
 */
export const pl = {
  emptyData: "Brak danych do wyświetlenia.",
  emptyList: "Brak ofert spełniających wybrane kryteria.",
  filterCategory: "Wszystkie kategorie",
  filterProvince: "Wszystkie województwa",
  filterCity: "Wszystkie miasta",
  filterSubmit: "Wyszukaj",
  filterReset: "Wyczyść filtry",
  filterLabelCategory: "Kategoria",
  filterLabelProvince: "Województwo",
  filterLabelCity: "Miasto",
  referenceNumber: "Numer referencyjny",
  publicationDate: "Data dodania ogłoszenia",
  tasksHeading: "Będziesz odpowiedzialny za:",
  expectationsHeading: "Oczekujemy od Ciebie:",
  offerHeading: "Oferujemy:",
  applyButton: "Aplikuj",
  goToForm: "Przejdź do formularza",
  attachments: "Załączniki",
  download: "Pobierz",
  readMore: "Czytaj więcej ->",
  backToList: "<- Wróć do listy ofert",
  /** `formatDate("2026-05-13")` -> "13 maja 2026". */
  formatDate: (iso: string): string => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    if (!m) return iso;
    const months = [
      "stycznia", "lutego", "marca", "kwietnia", "maja", "czerwca",
      "lipca", "sierpnia", "września", "października", "listopada", "grudnia",
    ];
    const month = parseInt(m[2], 10) - 1;
    if (month < 0 || month > 11) return iso;
    return `${parseInt(m[3], 10)} ${months[month]} ${m[1]}`;
  },
  /** `formatFileSize(123456)` -> "123 KB". */
  formatFileSize: (bytes: number): string => {
    if (!bytes || bytes < 0) return "0 B";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  },
} as const;

export type CJobOffersTranslations = DeepString<typeof pl>;
